$(function () {
fn_layout_footer();
fn_layout_header();
fn_layout_main();
fn_part_ui_cookies();
fn_part_ui_input();
fn_part_ui_wsw();
fn_comp_category();
fn_comp_contact();
fn_comp_events();
fn_comp_event_detail();
fn_comp_offers();
fn_comp_partners();
fn_comp_product_detail();
fn_comp_visual();
});